import React, { FC, useState, useCallback } from 'react'
import { Button } from '@wmgtech/legato'
import { useNavigate } from 'react-router-dom'
import { useAbility } from '@casl/react'
import { subject } from '@casl/ability'
import { useReactiveVar } from '@apollo/client'

import { AbilityContext } from 'shared/abilities'

import { labelCodeIdVar, spaceIdVar } from 'modulesCommon/store'
import { useZonesList } from 'modulesCommon/serviceHooks'

import { ProjectsTableHeader } from '..'
import { ZoneConfirmationModal } from 'modules/Feed/components'

import './ProjectHeader.scss'
import { useCurrentUser } from 'modules/User/useCurrentUser'
import { useZoneManager } from '../../../../shared/hooks/useZoneManager'

const ProjectHeader: FC = ({ children }) => {
  const [isConfirmation, toggleConfirmation] = useState(false)

  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const spaceId = useReactiveVar(spaceIdVar)

  const ability = useAbility(AbilityContext)
  const { getZoneById } = useZonesList()
  const { user } = useCurrentUser()
  const navigate = useNavigate()
  const { buildZoneUrl } = useZoneManager()
  const isZoneProjectPage = !!currentLabelId
  const canCreateCampaign = isZoneProjectPage && ability.can('create', subject(
    'Project',
    {
      id: '',
      label_id: currentLabelId
    }))

  const onAddStory = useCallback(
    () => currentLabelId && user?.label_id !== currentLabelId ?
      toggleConfirmation(true) : navigate(buildZoneUrl('projects/new')),
    [currentLabelId, user?.label_id, navigate, buildZoneUrl]
  )

  return (
    <div>
      <div className="project-header">
        {canCreateCampaign ? (
          <Button
            colorType="secondary-black"
            containerStyle="outline"
            secondaryIcon="circle-plus"
            label="Add a Project"
            className="project-header__add"
            onClick={onAddStory}
          />
        ) : null}
        <div className="project-header__info">{children}</div>
      </div>
      <ZoneConfirmationModal
        isOpen={isConfirmation}
        title={`New project in Zone ${getZoneById(currentLabelId)?.alias}?`}
        text={
          <>
            Are you sure you want to create a project in the zone <b>{getZoneById(currentLabelId)?.name}</b>?
          </>
        }
        onClose={() => toggleConfirmation(false)}
        onContinue={() => navigate(buildZoneUrl('projects/new'))}
      />
      <ProjectsTableHeader isSpace={!!spaceId} />
    </div>
  )
}

export default ProjectHeader
